"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledForm = exports.BuyButtonContainer = exports.SubsFullWidthButton = exports.SoldByContainer = exports.TwoColumnContainer = exports.MobileDivider = exports.CancellationContainer = exports.TermsContainer = exports.BuyBoxHeaderContainer = exports.SubsPaymentSummaryContainer = exports.SubsBuyBoxContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const divider_1 = require("../divider");
const themed_button_1 = require("../themed-button");
const themed_text_1 = require("../themed-text");
exports.SubsBuyBoxContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
`;
exports.SubsPaymentSummaryContainer = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    margin-top: ${(props) => props.theme.spacings.mini};
  }
`;
exports.BuyBoxHeaderContainer = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    margin-top: ${(props) => props.theme.spacings.mini};
    margin-bottom: ${(props) => props.theme.spacings.small};
  }
`;
exports.TermsContainer = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    margin-top: ${(props) => props.theme.spacings.medium};
  }
`;
exports.CancellationContainer = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    margin-top: ${(props) => props.theme.spacings.base};
    margin-bottom: 0;
  }
`;
exports.MobileDivider = (0, styled_components_1.default)(divider_1.Divider) `
  height: ${(props) => props.height};
  width: auto;
  background-color: #e0e4e6;
  height: 0.5rem;
`;
exports.TwoColumnContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-direction: row;
  margin-top: ${(props) => props.theme.spacings.medium}; ;
`;
exports.SoldByContainer = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
  margin-top: ${(props) => props.theme.spacings.medium};
`;
exports.SubsFullWidthButton = (0, styled_components_1.default)(themed_button_1.ThemedButton) `
  width: 100%;
  height: auto;
  min-height: 45px;
  border-radius: 24px;
  font-size: 16px;
  line-height: 21px;
`;
exports.BuyButtonContainer = styled_components_1.default.div `
  margin: ${(props) => props.theme.spacings.medium} 0 0 0;
`;
exports.StyledForm = styled_components_1.default.form `
  margin: 0 0 0 0;
`;
